/**
 * CR550: Region filter dropdown for Merchant Directory
 */

import { MapPin, X } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import type { Region } from "@/lib/regions/types";

interface RegionFilterDropdownProps {
  regions: Region[];
  selectedRegionId: string | null;
  onRegionChange: (regionId: string | null) => void;
  loading?: boolean;
}

export function RegionFilterDropdown({
  regions,
  selectedRegionId,
  onRegionChange,
  loading,
}: RegionFilterDropdownProps) {
  return (
    <div className="flex items-center gap-2">
      <MapPin className="h-4 w-4 text-muted-foreground" />
      <Select
        value={selectedRegionId ?? "__all__"}
        onValueChange={(val) => onRegionChange(val === "__all__" ? null : val)}
      >
        <SelectTrigger className="w-[220px]">
          <SelectValue placeholder="All regions" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__all__">All regions</SelectItem>
          {regions.map((r) => (
            <SelectItem key={r.id} value={r.id}>
              {r.label} ({r.postal_code})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {selectedRegionId && (
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8"
          onClick={() => onRegionChange(null)}
        >
          <X className="h-4 w-4" />
        </Button>
      )}
      {loading && (
        <span className="text-xs text-muted-foreground animate-pulse">Loading…</span>
      )}
    </div>
  );
}
